module.exports = __webpack_public_path__ + "static/media/bannerLoja.8641ba2d.png";